import React from "react";
import PublicPage from "@/components/public/PublicPage";
import MultiLocationSection from "@/components/home/MultiLocationSection";

export default function MultiLocation() {
  return (
    <PublicPage
      eyebrow="Multi-Location"
      title="Manage Every Location From One Dashboard"
      intro="Each location completes its own checks through the mobile app while management monitors activity, incidents, overdue work and compliance records centrally."
    >
      <MultiLocationSection />
    </PublicPage>
  );
}
